import React from 'react';

export const textToKey = (text: string) => text.replace(/ /g, '_');

const WrapInTextComponent = ({ children }: { children: React.ReactNode }) => <>{children}</>;
WrapInTextComponent.displayName = 'WrapInText';

export const wrapInText = (...wrapFns: Array<(part: string) => React.ReactNode>) =>
    function WrapInText(text: string) {
        let currentIdx = 0;
        const result: React.ReactNode[] = [];
        let iteration = 0;

        while (true) {
            const openIdx = text.indexOf('[', currentIdx);
            const closeIdx = text.indexOf(']', openIdx);
            if (openIdx === -1 || closeIdx === -1) {
                break;
            }
            result.push(
                <React.Fragment key={'text-' + iteration}>{text.substring(currentIdx, openIdx)}</React.Fragment>,
                <React.Fragment key={'wrap-' + iteration}>
                    {wrapFns[iteration](text.substring(openIdx + 1, closeIdx))}
                </React.Fragment>,
            );
            currentIdx = closeIdx + 1;
            iteration++;
        }
        result.push(<React.Fragment key="text-closing">{text.substring(currentIdx)}</React.Fragment>);
        return <WrapInTextComponent>{result}</WrapInTextComponent>;
    };
